import { getDatabaseContainerType, type AnalyticsClient } from '@databases/analytics';
import type { MessageFormatter } from '@databases/intl/intl-types';

import { type BuildProps, type User } from './types.ts';

export class BaseMentionBuilder {
  protected formatMessage: MessageFormatter;
  protected usersWithAccess: User[];
  protected usersWithoutAccess: User[];
  protected isLocked: boolean;
  protected openFieldSettings: (fieldId: string) => void;
  protected dismissFlag: (flagId: string) => void;
  protected mentionNotificationDescription: string;
  protected fieldSettingsActionLabel: string;
  protected fieldId: string;
  protected analyticsClient: AnalyticsClient;
  protected contentId: string;

  constructor({
    formatMessage,
    usersWithAccess,
    usersWithoutAccess,
    isLocked,
    openFieldSettings,
    dismissFlag,
    mentionNotificationDescription,
    fieldSettingsActionLabel,
    fieldId,
    analyticsClient,
    contentId
  }: BuildProps) {
    this.formatMessage = formatMessage;
    this.usersWithAccess = usersWithAccess;
    this.usersWithoutAccess = usersWithoutAccess;
    this.isLocked = isLocked;
    this.openFieldSettings = openFieldSettings;
    this.dismissFlag = dismissFlag;
    this.mentionNotificationDescription = mentionNotificationDescription;
    this.fieldSettingsActionLabel = fieldSettingsActionLabel;
    this.fieldId = fieldId;
    this.analyticsClient = analyticsClient;
    this.contentId = contentId;
  }

  protected buildFieldSettingsAction(flagId: string) {
    return {
      content: this.fieldSettingsActionLabel,
      onClick: () => {
        this.openFieldSettings(this.fieldId);

        this.analyticsClient.sendMentionNotificationActionEvent({
          contentId: this.contentId,
          databaseContainer: getDatabaseContainerType()
        });

        this.dismissFlag(flagId);
      }
    };
  }
}
